import React from 'react';
import { Checkbox } from 'antd';
import { readPlatformFlags, togglePlatformFlag } from '../platform-visibility';

const PlatformTags = ({ value = [], onChange }) => {
  const platformOptions = [
    {
      key: 'isweb',
      label: 'Web',
      tooltip: 'Show this product on the web platform',
    },
    {
      key: 'iskiosk',
      label: 'Kiosk',
      tooltip: 'Show this product on kiosk terminals',
    },
    {
      key: 'ismobile',
      label: 'Mobile',
      tooltip: 'Show this product on mobile apps',
    },
  ];

  const currentValues = readPlatformFlags(value);

  const handleChange = (key, checked) => {
    onChange(togglePlatformFlag(value, key, checked));
  };

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 dark:text-slate-400">
        Platform Visibility
      </label>
      <p className="font-normal text-xs text-gray-500 dark:text-slate-400">
        Choose where to show this product. Leave blank to display on all
        platforms.
      </p>

      <div className="flex items-center space-x-6 mt-3">
        {platformOptions.map((option) => (
          <div key={option.key} className="flex items-center space-x-2">
            <Checkbox
              checked={currentValues[option.key] || false}
              onChange={(e) => handleChange(option.key, e.target.checked)}
            />
            <span className="text-sm font-medium text-gray-900 dark:text-slate-200 ">
              {option.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlatformTags;
